import Header from "@/components/landing/Header";
import { SEOHead } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";
import Footer from "@/components/landing/Footer";
import FAQHero from "@/components/landing/faq/FAQHero";
import FAQContent from "@/components/landing/faq/FAQContent";
import CTASection from "@/components/landing/CTASection";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  createWebPageSchema,
  createFAQSchema,
} from "@/hooks/useStructuredData";

interface FAQCategory {
  id: string;
  title: string;
  items: { question: string; answer: string }[];
}

const FAQ = () => {
  const { language, t, tObject } = useLanguage();

  const faqCategories = tObject<FAQCategory[]>("faqContent.categories");
  const faqItems = faqCategories.flatMap((cat) => cat.items);

  return (
    <div className="min-h-screen bg-background">
      <SEOHead page="faq" locale={language} />
      <StructuredDataHead schemas={[
        organizationSchema,
        createWebPageSchema(
          t("faqPage.title"),
          t("faqPage.description"),
          "/faq",
          [
            { name: "Home", url: "/" },
            { name: "FAQ", url: "/faq" },
          ]
        ),
        createFAQSchema(faqItems),
      ]} />
      <LLMMetadataHead
        title={t("faqPage.title")}
        description={t("faqPage.description")}
        keywords="Chathero FAQ, AI Agent, Chatbot, WhatsApp Integration, GDPR"
        canonicalUrl="https://chathero.ai/faq"
        aiCategory="FAQ"
        aiEntityType="FAQ Page"
      />
      <Header />
      <main>
        <FAQHero />
        <FAQContent />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default FAQ;
